import _ from 'lodash';

export {
  convertTreeMap,
  getPropertiesValues,
  convertExchange,
  getListRemoveDuplicate,
  filterByList,
  groupBy,
};

const lstExchange = {
  VNINDEX: 'HOSE',
  HNXINDEX: 'HNX',
  UPCOMINDEX: 'UPCOM',
};

const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

function convertTreeMap(arr, keyGroup, keyGroupChild) {
  let tree = [],
    mappedArr = {};
  // First map the nodes of the array to an object -> create a hash table.
  _.map(arr, (arrElem, index) => {
    mappedArr[arrElem[keyGroup]] = arrElem;
    mappedArr[arrElem[keyGroup]]['children'] = [];
  });
  _.forOwn(mappedArr, (mappedElem, key) => {
    // If the element is not at the root level, add it to its parent array of children.
    if (mappedElem[keyGroupChild]) {
      mappedArr[mappedElem[keyGroupChild]]['children'].push(mappedElem);
    }
    // If the element is at the root level, add it to first level elements array.
    else {
      tree.push(mappedElem);
    }
  });
  return tree;
}

function getPropertiesValues(arr, keyProperties) {
  _.mixin({
    toPairsDeep: obj =>
      _.flatMap(_.toPairs(obj), ([k, v]) =>
        _.isObjectLike(v) ? _.toPairsDeep(v) : [[k, v]],
      ),
  });

  return _(arr)
    .toPairsDeep()
    .filter(([k, v]) => k === keyProperties)
    .map(1)
    .value();
}

function convertExchange(items) {
  items = !_.isEmpty(items) ? items : [];
  items = _.map(items, item => {
    item.nameAndExchange = item.comGroupCode
      ? lstExchange[item.comGroupCode.toUpperCase()]
      : '';
    return item;
  });
}

function getListRemoveDuplicate(lstTicker, listLoadMore, keyCol) {
  const lstDuplicate = _.filter(lstTicker, (val, i, iteratee) =>
    _.includes(iteratee, val, i + 1),
  );
  listLoadMore = _.filter(
    listLoadMore,
    el => !_.includes(lstDuplicate, el[keyCol]),
  );
  const listLoadMoreByTicker = _.keyBy(listLoadMore, keyCol);
  return listLoadMoreByTicker;
}

function filterByList(items, listCompare, keyCol) {
  return !_.isEmpty(listCompare)
    ? _.filter(items, item => _.includes(listCompare, item[keyCol]))
    : items;
}
